import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBookSimple"><Path fillRule="evenodd" clipRule="evenodd" d="M6.5 2C5.11929 2 4 3.11929 4 4.5V19.5C4 20.8807 5.11929 22 6.5 22H17.5C18.8807 22 20 20.8807 20 19.5V4.5C20 3.11929 18.8807 2 17.5 2H6.5ZM5 19.5C5 20.3284 5.67157 21 6.5 21H17.5C18.3284 21 19 20.3284 19 19.5V17.5002C18.5822 17.814 18.0628 18 17.5 18H6.5C5.67157 18 5 18.6716 5 19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookSimple;
